import { DataTypeEnum, DomainEnum } from "../properties/pl-properties.types";

export interface SubPropertiesState {
  byParentPropertyId: any;
  allParentPropertyIds: any;
  newSubProperty: any;
  getting: boolean;
  deleting: boolean;
  posting: boolean;
}

export enum StandardSubproperties {
  ADVANTAGE = ".ADVANTAGE",
  ALERT = ".ALERT",
  BOLD = ".BOLD",
  CHILDREN = ".CHILDREN",
  CONTROLTYPE = ".CONTROLTYPE",
  DEFAULT = ".DEFAULT",
  DESCRIPTION = ".DESCRIPTION",
  DETAILS = ".DETAILS",
  DISCOUNT = ".DISCOUNT",
  DISPLAYUNIT = ".DISPLAYUNIT",
  DISPLAYUNIT_DEFAULT = ".DISPLAYUNIT.DEFAULT",
  DOCUMENTATION = ".DOCUMENTATION",
  ENABLED = ".ENABLED",
  FIX = ".FIX",
  FIX_DEFAULT = ".FIX.DEFAULT",
  GALLERY = ".GALLERY",
  HIDEINFEASIBLE = ".HIDEINFEASIBLE",
  INCLUDED = ".INCLUDED",
  MIN = ".MIN",
  MAX = ".MAX",
  MESSAGE = ".MESSAGE",
  MESSAGE_LEVEL = ".MESSAGE_LEVEL",
  MLP = ".MLP",
  MSG_INFO = ".MSG_INFO",
  MSG_WARNING = ".MSG_WARNING",
  MSG_ERROR = ".MSG_ERROR",
  ORDER = ".ORDER",
  PERCENT = ".PERCENT",
  PRICEKEY = ".PRICEKEY",
  UNIT = ".UNIT",
  UNIT_DEFAULT = ".UNIT.DEFAULT",
  VALID = ".VALID",
  VISIBLE = ".VISIBLE",
}

export const StandardSubPropertiesOptions = Object.keys(StandardSubproperties);

export const standardSubPropertiesObject = {
  ".ADVANTAGE": {
    name: StandardSubproperties.ADVANTAGE,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".ALERT": {
    name: StandardSubproperties.ALERT,
    dataType: DataTypeEnum.BOOL,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".BOLD": {
    name: StandardSubproperties.BOLD,
    dataType: DataTypeEnum.BOOL,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".CHILDREN": {
    name: StandardSubproperties.CHILDREN,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".CONTROLTYPE": {
    name: StandardSubproperties.CONTROLTYPE,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".DEFAULT": {
    name: StandardSubproperties.DEFAULT,
    dataType: DataTypeEnum.BOOL, // determined by the main property
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".DESCRIPTION": {
    name: StandardSubproperties.DESCRIPTION,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".DETAILS": {
    name: StandardSubproperties.DETAILS,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".DISCOUNT": {
    name: StandardSubproperties.DISCOUNT,
    dataType: DataTypeEnum.FLOAT,
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".DISPLAYUNIT": {
    name: StandardSubproperties.DISPLAYUNIT,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".DISPLAYUNIT.DEFAULT": {
    name: StandardSubproperties.DISPLAYUNIT_DEFAULT,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".DOCUMENTATION": {
    name: StandardSubproperties.DOCUMENTATION,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".ENABLED": {
    name: StandardSubproperties.ENABLED,
    dataType: DataTypeEnum.BOOL,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".FIX": {
    name: StandardSubproperties.FIX,
    dataType: DataTypeEnum.BOOL,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".FIX.DEFAULT": {
    name: StandardSubproperties.FIX_DEFAULT,
    dataType: DataTypeEnum.BOOL,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".GALLERY": {
    name: StandardSubproperties.GALLERY,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".HIDEINFEASIBLE": {
    name: StandardSubproperties.HIDEINFEASIBLE,
    dataType: DataTypeEnum.BOOL,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".INCLUDED": {
    name: StandardSubproperties.INCLUDED,
    dataType: DataTypeEnum.BOOL,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".MIN": {
    name: StandardSubproperties.MIN,
    dataType: DataTypeEnum.INT, // determined by the main property
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".MAX": {
    name: StandardSubproperties.MAX,
    dataType: DataTypeEnum.INT, // determined by the main property
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".MESSAGE": {
    name: StandardSubproperties.MESSAGE,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".MESSAGE_LEVEL": {
    name: StandardSubproperties.MESSAGE_LEVEL,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".MLP": {
    name: StandardSubproperties.MLP,
    dataType: DataTypeEnum.FLOAT,
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".MSG_INFO": {
    name: StandardSubproperties.MSG_INFO,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".MSG_WARNING": {
    name: StandardSubproperties.MSG_WARNING,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".MSG_ERROR": {
    name: StandardSubproperties.MSG_ERROR,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".ORDER": {
    name: StandardSubproperties.ORDER,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".PERCENT": {
    name: StandardSubproperties.PERCENT,
    dataType: DataTypeEnum.FLOAT,
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".PRICEKEY": {
    name: StandardSubproperties.PRICEKEY,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.OPEN,
    ruleSets: [],
    tags: [],
  },
  ".UNIT": {
    name: StandardSubproperties.UNIT,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".UNIT.DEFAULT": {
    name: StandardSubproperties.UNIT_DEFAULT,
    dataType: DataTypeEnum.STRING,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".VALID": {
    name: StandardSubproperties.VALID,
    dataType: DataTypeEnum.BOOL,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
  ".VISIBLE": {
    name: StandardSubproperties.VISIBLE,
    dataType: DataTypeEnum.BOOL,
    domain: DomainEnum.DISCRETE,
    ruleSets: [],
    tags: [],
  },
};
